var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 6.2145C20.3385 6.5075 19.627 6.703 18.8765 6.7955C19.6395 6.3425 20.2265 5.62 20.502 4.7665C19.788 5.185 18.997 5.4925 18.1555 5.6545C17.4835 4.942 16.525 4.5 15.463 4.5C13.423 4.5 11.7695 6.139 11.7695 8.16C11.7695 8.446 11.803 8.7245 11.866 8.995C8.79697 8.841 6.07497 7.382 4.25397 5.168C3.93397 5.709 3.75397 6.3425 3.75397 7.011C3.75397 8.2815 4.40447 9.4 5.39647 10.059C4.79097 10.0405 4.22097 9.872 3.72197 9.602C3.72197 9.613 3.72197 9.6295 3.72197 9.645C3.72197 11.4205 4.99547 12.899 6.68347 13.2355C6.37497 13.32 6.04897 13.367 5.71297 13.367C5.47447 13.367 5.24197 13.34 5.01697 13.2995C5.48697 14.7505 6.85047 15.811 8.46597 15.8425C7.20197 16.8225 5.60997 17.4095 3.87897 17.4095C3.57997 17.4095 3.28747 17.3925 2.99847 17.3575C4.63397 18.393 6.57597 19 8.66047 19C15.453 19 19.169 13.422 19.169 8.583C19.169 8.4245 19.164 8.2665 19.1565 8.1105C19.8815 7.5985 20.5065 6.9525 21 6.2145Z",
    fill: "#03A9F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsTwitter);
export default __webpack_public_path__ + "static/media/WHSTwitter.becb71a2b48427f2f444a303a09796d9.svg";
export { ForwardRef as ReactComponent };